import { Document, Enterprise, Insured } from '../models/models';
import { environment } from '../../environments/environment';
import { Browser } from '@capacitor/browser';
import { ApiService } from './api.service';
import { CreateDocumentDTO, FileDTO, UpdateDocumentDTO } from '../models/dto';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DocumentService {
  constructor(private apiService: ApiService) {}

  async getDocuments(
    source: 'mutuelle' | 'enterprise' | 'insured',
    id: string = null,
    pattern: string = null,
    sort: 'title' | 'toBeCompleted' | 'size' | 'createdAt' = null,
    dir: 'asc' | 'desc' = null
  ): Promise<Document[]> {
    // id : enterprise id, insured id, or mutuelle code
    let route;
    switch (source) {
      case 'mutuelle':
      case 'enterprise':
        route = 'enterprises/' + id + '/documents';
        break;
      case 'insured':
        route = 'members/' + id + '/documents';
        break;
    }
    const params = new URLSearchParams();
    if (pattern) {
      params.set('search', pattern);
    }
    if (sort) {
      params.set('sort', sort);
    }
    if (dir) {
      params.set('dir', dir);
    }
    const q = params.toString();
    if (q) {
      route += '?' + q;
    }
    return new Promise(async (resolve, reject) => {
      this.apiService.get<Document[]>(route, true).subscribe({
        next: (res) => {
          resolve(res.map((d) => new Document(d)));
        },
        error: (res) => {
          console.log(res?.error);
          reject(res?.error);
        },
      });
    });
  }

  async getDocument(uuid: string): Promise<Document> {
    return new Promise(async (resolve, reject) => {
      this.apiService.get<Insured>('/documents/' + uuid, true).subscribe({
        next: (res) => {
          resolve(new Document(res));
        },
        error: (res) => {
          console.log(res?.error);
          reject(res?.error);
        },
      });
    });
  }

  // downloadSourceFile(uuid: string) {
  //   Browser.open({
  //     url:
  //       environment.apiBaseUrl +
  //       '/documents/files/' +
  //       uuid +
  //       '/download?token=' +
  //       ApiService.token +
  //       '&mutuelle=' +
  //       environment.mutuelleCode,
  //     windowName: '_blank',
  //   });
  // }

  // downloadCompletedFile(uuid: string) {
  //   Browser.open({
  //     url:
  //       environment.apiBaseUrl +
  //       '/documents/files/completed/' +
  //       uuid +
  //       '/download?token=' +
  //       ApiService.token +
  //       '&mutuelle=' +
  //       environment.mutuelleCode,
  //     windowName: '_blank',
  //   });
  // }

  async createDocument(data: CreateDocumentDTO): Promise<Document> {
    return new Promise(async (resolve, reject) => {
      this.apiService.post<Document>('/documents', data, true).subscribe({
        next: (res) => {
          resolve(res);
        },
        error: (res) => {
          console.log(res?.error);
          reject(res?.error);
        },
      });
    });
  }

  async updateDocument(uuid: string, data: UpdateDocumentDTO): Promise<any> {
    return new Promise(async (resolve, reject) => {
      this.apiService
        .put<Document>('/documents/' + uuid, data, true)
        .subscribe({
          next: (res) => {
            resolve(true);
          },
          error: (res) => {
            console.log(res?.error);
            reject(res?.error);
          },
        });
    });
  }

  async deleteDocument(uuid: string): Promise<any> {
    return new Promise(async (resolve, reject) => {
      this.apiService.delete<Document>('/documents/' + uuid, true).subscribe({
        next: (res) => {
          resolve(true);
        },
        error: (res) => {
          console.log(res?.error);
          reject(res?.error);
        },
      });
    });
  }

  async shareDocuments(data: any): Promise<any> {
    return new Promise(async (resolve, reject) => {
      this.apiService.post<any>('/shared-access', data, true).subscribe({
        next: (res) => {
          resolve(true);
        },
        error: (res) => {
          console.log(res?.error);
          reject(res?.error);
        },
      });
    });
  }

  downloadDocuments(documents: string[]): Promise<any> {
    return new Promise(async (resolve, reject) => {
      this.apiService
        .post<any>('/documents/downloads', { documents }, true)
        .subscribe({
          next: (res) => {
            Browser.open({ url: res.url, windowName: '_blank' });
            resolve(true);
          },
          error: (res) => {
            console.log(res?.error);
            reject(res?.error);
          },
        });
    });
  }

  addToLibrary(documents: string[]): Promise<any> {
    return new Promise(async (resolve, reject) => {
      this.apiService
        .post<any>('/documents/add-to-library', { documents }, true)
        .subscribe({
          next: async (res) => {
            resolve(true);
          },
          error: (res) => {
            console.log(res?.error);
            reject(res?.error);
          },
        });
    });
  }

  uploadArchive(archive: string, enterprise: Enterprise): Promise<boolean> {
    return new Promise(async (resolve, reject) => {
      this.apiService
        .post<{ success: boolean }>(
          '/documents/upload-archive',
          {
            archive,
            enterpriseId: enterprise.id,
            enterpriseName: enterprise.name,
          },
          true
        )
        .subscribe({
          next: async () => {
            resolve(true);
          },
          error: (res) => {
            console.log(res?.error);
            reject(res?.error);
          },
        });
    });
  }
}
